import { getPictoByThemeId } from '../../utils/pictos'

const AdditionalSalesGrid = ({ additionalSales, onThemeClick, setShowDetailsFor }) => {
  let activeInterval = null
  const handleThemeClick = onThemeClick ?? setShowDetailsFor

  return (
    <>
      {additionalSales && (
        <div className="additionalSalesGrid">
          {additionalSales.intervals.map((interval) => {
            // Regroupement des sessions par theme_id
            const availabilityCountByTheme = interval.sessions.reduce((acc, session) => {
              const themeId = session.room.theme_id
              if (!acc[themeId]) {
                acc[themeId] = 0
              }
              if (session.available) acc[themeId]++
              return acc
            }, {})

            const sessionStartDate = new Date(interval.start)
            const sessionStartTime = sessionStartDate.toLocaleTimeString('fr-FR', {
              hour: '2-digit',
              minute: '2-digit',
            })

            const now = new Date()
            if (!activeInterval && !(now > sessionStartDate)) {
              activeInterval = interval
            }

            return (
              <div
                className={'interval ' + (activeInterval === interval ? 'active' : '')}
                key={interval.start}
              >
                <div className="intervalTime">{sessionStartTime}</div>
                {Object.entries(availabilityCountByTheme).map(([themeId, availabilityCount]) => {
                  const Picto = getPictoByThemeId(themeId)
                  return (
                    <div
                      className="themeGroup"
                      key={themeId}
                      onClick={() => handleThemeClick?.(themeId)}
                    >
                      <Picto className={`picto ${availabilityCount > 0 ? '' : 'disabled'}`}></Picto>
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
      )}
    </>
  )
}

export default AdditionalSalesGrid
